import { PowerSkillAnswerOption } from "../typings/powerskill";

const getAnswerOptions = (): PowerSkillAnswerOption[] => {
  return [
    {
      score: 1,
      label: "Tidak Pernah",
    },
    {
      score: 2,
      label: "Jarang",
    },
    {
      score: 3,
      label: "Kadang Kadang",
    },
    {
      score: 4,
      label: "Sering",
    },
    {
      score: 5,
      label: "Selalu",
    },
  ];
};

const getAnswerOptionLabels = (score: number | null): PowerSkillAnswerOption|undefined => {
  return getAnswerOptions().find(a => a.score === score);
};

const getCategoryName = (type: string): string => {
  const categories: Record<string, string> = {
    A: "Mengatur Diri & Tanggung Jawab",
    B: "Cara Berpikir & Memecahkan Masalah",
    C: "Berkomunikasi dengan Baik",
    D: "Bekerja Sama & Menghargai Orang Lain",
    E: "Sikap Positif & Mau Belajar",
  };
  return categories[type] || type;
};

const formatBold = (text: string | undefined): string => {
  if (!text) return "";
  return text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
};

export { getAnswerOptions, getAnswerOptionLabels, getCategoryName, formatBold };
